export default {
  loading: false,
  data: null,
  error: null,
};
